// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"447f5ee6","707":"381f8b96","729":"8ccfc3c8"}[chunkId] + ".js";
};